;(function () {
  'use strict'

  angular
    .module('contrast.app')
    .factory('GlobalFactory', ['$http', GlobalFactory])

  function GlobalFactory($http) {
    var service = {
      getDateFormats: getDateFormats,
      getTimeFormats: getTimeFormats,
      getTimeZones: getTimeZones,
      getTimeouts: getTimeouts,
      getProgressTaskMap: getProgressTaskMap,
      getTeamServerProperties: getTeamServerProperties,
      getCategories: getCategories,
      getAuthSettings: getAuthSettings
    }

    return service

    function getDateFormats() {
      return $http.get('/Contrast/api/ng/global/dateformats')
    }

    function getTimeFormats() {
      return $http.get('/Contrast/api/ng/global/timeformats')
    }

    function getTimeZones() {
      return $http.get('/Contrast/api/ng/global/timezones')
    }

    function getTimeouts() {
      return $http.get('/Contrast/api/ng/global/timeouts')
    }

    function getProgressTaskMap(jobId) {
      return $http.get('/Contrast/api/ng/global/progress/' + jobId)
    }

    function getTeamServerProperties() {
      return $http.get('/Contrast/api/ng/global/properties')
    }

    function getCategories() {
      return $http.get('/Contrast/api/ng/global/rules/category')
    }

    function getAuthSettings() {
      return $http.get('/Contrast/api/ng/global/auth/settings')
    }
  }
})()
